import React, {useEffect, useState} from 'react';
import {LayoutChangeEvent} from 'react-native';
import {StoreGrid} from './styles';
import {ParceiroDTO} from '../../../../../../dtos/ParceiroDTO';
import {apiMasterClin} from '../../../../../../services/api';
import {StoreGridItem} from '../StoreGridItem';
import {useIsFocused} from '@react-navigation/native';
import {getCache, setCache, CACHE_KEYS} from '../../../../../../services/cache';

const NUM_COLS = 4;
const GRID_GAP = 16;
const MAX_ITEMS = 8;

const PRIORITY_NAMES = [
  'netshoes',
  'casas bahia',
  'electrolux',
  'vivara',
  'nike',
  'decolar',
  'renner',
  'riachuelo',
  'hering',
  'dominos',
  'unyleya',
  'movida',
];

function getPriority(nome: string): number {
  const lower = nome.toLowerCase();
  const idx = PRIORITY_NAMES.findIndex(p => lower.includes(p));
  return idx === -1 ? PRIORITY_NAMES.length : idx;
}

function extractDiscount(beneficio: string): string | null {
  const text = beneficio.replace(/<[^>]+>/g, ' ');
  const ateMatch = text.match(/até\s+(\d+(?:[.,]\d+)?)\s*%/i);
  if (ateMatch) {return `Até ${ateMatch[1]}%`;}
  const percentMatch = text.match(/(\d+(?:[.,]\d+)?)\s*%/);
  if (percentMatch) {return `${percentMatch[1]}%`;}
  return null;
}

export function StoreListHome({parceiros}: {parceiros?: ParceiroDTO[]}) {
  const isFocused = useIsFocused();
  const [containerWidth, setContainerWidth] = useState(0);

  function handleLayout(event: LayoutChangeEvent) {
    setContainerWidth(event.nativeEvent.layout.width);
  }

  const itemWidth =
    containerWidth > 0
      ? (containerWidth - GRID_GAP * (NUM_COLS - 1)) / NUM_COLS
      : 0;

  const [parceirosDestaque, setParceirosDestaque] = useState<ParceiroDTO[]>(
    parceiros ? parceiros : [],
  );

  useEffect(() => {
    let isMounted = true;

    async function getParceiros() {
      const cached = await getCache<ParceiroDTO[]>(CACHE_KEYS.MASTERCLIN_DESTAQUES);
      if (cached && isMounted) {
        setParceirosDestaque(cached);
        return;
      }

      await apiMasterClin.get('/parceiro/obter-destaques').then(({data}) => {
        const {parceiros: fetched} = data;
        if (isMounted) {
          setParceirosDestaque(fetched);
          setCache(CACHE_KEYS.MASTERCLIN_DESTAQUES, fetched);
        }
      });
    }

    if (!parceiros) {
      getParceiros();
    }

    return () => {
      isMounted = false;
    };
  }, [isFocused]);

  useEffect(() => {
    if (parceiros) {
      setParceirosDestaque(parceiros);
    }
  }, [parceiros]);

  const storesWithDiscount = parceirosDestaque
    .filter(p => extractDiscount(p.beneficio) !== null)
    .sort((a, b) => getPriority(a.nome) - getPriority(b.nome))
    .slice(0, MAX_ITEMS);

  return (
    <StoreGrid rowGap={GRID_GAP} onLayout={handleLayout}>
      {containerWidth > 0 &&
        storesWithDiscount.map(parceiro => (
          <StoreGridItem
            key={parceiro.id}
            data={parceiro}
            discount={extractDiscount(parceiro.beneficio)!}
            itemWidth={itemWidth}
            verifyAccess
          />
        ))}
    </StoreGrid>
  );
}